export default "__VITE_ASSET__ec2b5e58__"